/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authOrgsGetRateLimit } from "../../funcs/authOrgsGetRateLimit.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetOrgRateLimitRequest$inboundSchema,
};

export const tool$authOrgsGetRateLimit: ToolDefinition<typeof args> = {
  name: "auth-orgs-get-rate-limit",
  description: `Get an org's rate limit`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authOrgsGetRateLimit(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
